import type { CSSProperties } from 'react';

import classnames from 'classnames';
import classNames from 'classnames';

import type { PostHeaderElementProps } from './PostHeader.types';
import { Serializer } from './serializer';

export function PostHeaderElement(props: PostHeaderElementProps) {
  const {
    element,
    children,
    attributes,
    className,
    isLive,
    disableEmbeds,
    utmParams,
    editorMode,
    onTitleChange,
    onSubtitleChange,
    isTitleSelected,
    isSubtitleSelected,
    renderBoundImage,
  } = props;

  const { customAttributes, margin, padding, data, gap, mobileGap, structureTiptapState } = element.attrs || {};
  const { post, breadcrumbs, shareUrl } = data || {};

  return (
    <div
      {...customAttributes}
      className={classNames('relative flex flex-col post-header-root-element', !isLive && 'pointer-events-none')}
      style={
        {
          width: '100%',
          margin,
          padding,
        } as CSSProperties
      }
      {...attributes}
    >
      <div
        className={classnames(className, customAttributes?.className, 'flex relative')}
        style={
          {
            '--gap': gap,
            '--mobile-gap': mobileGap !== undefined ? mobileGap : gap,
            width: '100%',
            margin,
            padding,
          } as CSSProperties
        }
      >
        <Serializer
          key={post.id}
          node={structureTiptapState?.content?.[0] as any}
          rootClassName={''}
          rootStyle={{}}
          post={post}
          breadcrumbs={breadcrumbs}
          isLive={isLive}
          disableEmbeds={disableEmbeds}
          utmParams={utmParams}
          shareUrl={shareUrl}
          editorMode={editorMode}
          onTitleChange={onTitleChange}
          onSubtitleChange={onSubtitleChange}
          isTitleSelected={isTitleSelected}
          isSubtitleSelected={isSubtitleSelected}
          renderBoundImage={renderBoundImage}
        />
      </div>

      {children}
    </div>
  );
}
